import { capitalizeFirstLetter } from '~/utils/utils'

export default function capitalizeFirstLetterFilter (string) {
  return capitalizeFirstLetter(string)
}
